import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { IAppInfo } from 'kts-platform-frame/dataModel';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    
    /** app应用列表 */
    public appList: IAppInfo[] = [];
}


// WEBPACK FOOTER //
// ./src/display/platform/MyApp/Modules.State.ts